// export const baseURL = "https://www.peakbooks.biz:2020/";
// export const baseURL = "http://159.122.225.148:2020/";
export const baseURL_Radio_Compaign = "https://radiocampaing.luckybox.ng/";
// export const baseURL = "https://luckybox.ng:1323/";
export const baseURL = "https://portalapi.luckybox.ng/";
// export const baseURL_Radio_Compaign = "https://luckybox.ng:1322/"; 
// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to  (at https://deno.land/std@v0.63.0/fmt/colors.ts)